import QRCode from 'qrcode.react'
import Box from '@material-ui/core/Box'
import { MY_PGA_COM_HOST } from 'env'
import propTypes from 'prop-types'

const QRCodeComponent = ({ classes, enrollmentUUID }) => {
  const timeStamp = new Date().toISOString().slice(0, 19)
  return (
    <Box
      display="flex"
      justifyContent="center"
      className={classes.componentSpacing}
      data-testid="payment-request-qr-code"
    >
      <QRCode
        value={`${MY_PGA_COM_HOST}/payment/${enrollmentUUID}?paymentRequestedDate=${timeStamp}`}
        size={178}
        level="H" // error correction level (H = high) for more squareness and less likely to be misread
      />
    </Box>
  )
}

QRCodeComponent.propTypes = {
  classes: propTypes.object,
  enrollmentUUID: propTypes.string,
}

export default QRCodeComponent
